import React from "react";
import { useTranslation } from "react-i18next";

const BackWin = () => {
  const { t } = useTranslation();
  const i18n = (key) => t(`promotions.return911Promotion.content.${key}`);

  return (
    <div className="p-4">
      <div className="mb-4">
        <p className="text-2xl font-bold mb-6">{i18n("activityDescription")}</p>
        <ul className="list-disc pl-5">
          <li>{i18n("lastDeposit")}</li>
          <li>{i18n("dailyDeposit")}</li>
        </ul>
      </div>
      <div className="border mb-6">
        <div className="flex border-b">
          <div className="flex-1 border-r p-2 text-center">
            {i18n("activityStandard")}
          </div>
          <div className="flex-1 border-r p-2 text-center">
            {i18n("bonusPercentage")}
          </div>
          <div className="flex-1 p-2 text-center">{i18n("bonusLimit")}</div>
        </div>
        <div className="flex">
          <div className="flex-1 border-r p-2 text-center">700,000 VND</div>
          <div className="flex-1 border-r p-2 text-center">8%</div>
          <div className="flex-1 p-2 text-center">8,000,000 VND</div>
        </div>
      </div>
      <div className="mt-4">
        <p className="text-2xl font-bold mb-6">{i18n("activityNotice")}</p>
        <ul className="list-disc pl-5 mt-2 flex flex-col gap-[10px]">
          <li>{i18n("reachStandard")}</li>
          <li>{i18n("effectiveBet")}</li>
          <li>{i18n("notWithOtherPromotions")}</li>
          {/* <li>{i18n("notApplicableGames")}</li> */}
          <li>{i18n("applyWithin24Hours")}</li>
          <li>{i18n("onePlayerOneDevice")}</li>
          <li>{i18n("rightToMonitor")}</li>
        </ul>
      </div>
    </div>
  );
};

export default BackWin;
